module.exports = __webpack_public_path__ + "resources/DeviceTouch.rar";


//////////////////
// WEBPACK FOOTER
// ./~/file-loader?name=resources/[name].[ext]!./DeviceNetwork/downloads/DeviceTouch.rar
// module id = 85
// module chunks = 0 40